import { useMapsLibrary } from "@vis.gl/react-google-maps";

// Single source of truth for "the Google Maps API is usable".
//
// APIProvider (mounted app-wide in _app.js) is the ONLY script loader; this
// hook reports readiness reactively via vis.gl. Two loaders racing (the old
// useJsApiLoader here + APIProvider) clobbered the google.maps namespace on
// cold deep-loads ("google.maps.Map is not a constructor") — never reintroduce
// a second loader.
//
// We wait for the libraries the app touches imperatively: "maps" (the
// google.maps.Map constructor used by legacy @react-google-maps/api
// components) and "places" (Autocomplete). Must be called under APIProvider.
export function useGoogleMapsLoaded() {
    const maps = useMapsLibrary("maps");
    const places = useMapsLibrary("places");
    return !!(maps && places);
}
